import React, { useEffect, useState, useRef, useContext } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Tab, Tabs } from 'react-bootstrap'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import defaultPalettes from '../Palettes';
import GlobalContext from '../GlobalContext';
import ImageInput from '../components/ImageInput';
import { useNavigate } from 'react-router-dom';
import { useImmer } from 'use-immer';
import "../css/sidebar.css"
import "../css/inputs.css"
import { RiDeleteBin6Line, RiFontSize, RiCheckLine, RiCloseLine, RiContactsBookLine, RiCalendar2Line, RiMenuAddLine, RiEraserLine, RiGoogleLine } from 'react-icons/ri'
import { AiFillEyeInvisible } from 'react-icons/ai'
import GoodCheck from '../components/GoodCheck';
import ServiceContext from '../ServiceContext';
import TextContext from '../TextContext';
import socketIO from "socket.io-client";
import GoodNumber from '../components/GoodNumber';

function decimalToHex(d, padding) {
    var hex = Number(d).toString(16);
    padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;

    while (hex.length < padding) {
        hex = "0" + hex;
    }

    return hex;
}
const fontOptions = [
    { label: "Georgia", value: "Georgia, serif" },
    { label: "Times New Roman", value: "Times New Roman, serif" },
    { label: "Arial", value: "Arial, sans-serif" },
    { label: "Tahoma", value: "Tahoma, sans-serif" },
    { label: "Trebuchet MS", value: "Trebuchet MS, sans-serif" },
    { label: "Verdana", value: "Verdana, sans-serif" },
    { label: "Courier New", value: "Courier New, monospaced" },
    { label: "tw_cen_mt", value: "tw_cen_mt, serif" },
    { label: "tw_cen_mtbold", value: "tw_cen_mtbold, serif" },
    { label: "tw_cen_mt_bold_italic", value: "tw_cen_mt_bold_italic, serif" },
    { label: "tw_cen_mt_condensedregular", value: "tw_cen_mt_condensedregular, serif" },
    { label: "tw_cen_mt_condensedbold", value: "tw_cen_mt_condensedbold, serif" },
    { label: "tw_cen_mt_condensed_extra_bRg", value: "tw_cen_mt_condensed_extra_bRg, serif" },
    { label: "tw_cen_mt_condensedmedium", value: "tw_cen_mt_condensedmedium, serif" },
]
const isInteger = (number) => {
    if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
    return !(number - parseInt(number));
}

const ThemeSettings = ({setShowSettings, editUser, temp}) => {

    const globalContext=useContext(GlobalContext)
    const textContext=useContext(TextContext)
    const serviceContext=useContext(ServiceContext)
    const animatedComponents = makeAnimated();
    const [showSave, setShowSave] = useState(false)
    const [showAddTheme, setShowAddTheme] = useState(false)
    const [resetColors, setResetColors] = useState(true)
    const [selectedFont, setSelectedFont] = useState({ text: fontOptions.filter(f => f.value == globalContext.get.Theme.text_font)[0], title: fontOptions.filter(f => f.value == globalContext.get.Theme.title_font)[0] })
    const [shadowOpacity, setShadowOpacity] = useState(32)
    const [newThemeName, setNewThemeName] = useState("")
    const [themeOptions, setThemeOptions] = useState(defaultPalettes.map(palette => ({ label: palette.name, value: palette.name })))
    const [editThemeCheks, setEditThemeCheks] = useImmer({
        touched: {
            name: false,
        },
        check: {
            name: (v) => { return v && v.length > 0 && v.length < 15 },
        },
        good: {
            name: false,
        },
        bad: {
            name: false,
        },
    })
    
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const checkForm = (values, check, setCheck, show = false) => {
        try {
            let pass = true
            Object.keys(values).forEach(k => {
                if (check.check.hasOwnProperty(k)) {
                    if (check.check[k](values[k])) {

                        if (show || check.touched[k]) {
                            setCheck(draft => { draft.good[k] = true })
                            setCheck(draft => { draft.bad[k] = false })
                        }
                    } else {
                        pass = false

                        if (show || check.touched[k]) {
                            setCheck(draft => { draft.bad[k] = true })
                            setCheck(draft => { draft.good[k] = false })
                        }
                    }
                } else {
                    //console.log('CHECK: proprietà non trovata:', k)
                }

            })
            return pass
        } catch (e) {
            console.log('Errore nel check', e)
            return false
        }
    }
    const addTheme = async () => {
        if (!checkForm({ name: newThemeName }, editThemeCheks, setEditThemeCheks)) {
            return
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })

        const fontBody = {
            fon_text: globalContext.get.Theme.text_font,
            fon_title: globalContext.get.Theme.title_font,
            fon_size: globalContext.get.Theme.text_size
        }

        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/fonts`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(fontBody)
        })
        let respValue = await resp.json()
        if (resp.status == 200) {
            const font_ID = respValue.data.ID
            //console.log(palID)
            const body = {
                pal_name: newThemeName,
                Font_ID: font_ID,
                color_1: globalContext.get.Theme.palette[0],
                color_2: globalContext.get.Theme.palette[1],
                color_3: globalContext.get.Theme.palette[2],
                color_4: globalContext.get.Theme.palette[3],
                color_5: globalContext.get.Theme.palette[4],
                color_6: globalContext.get.Theme.palette[5],
                color_7: globalContext.get.Theme.palette[6],
            }

            //console.log(body)
            resp = await fetch(`${globalContext.get.backendUrl}/papiv1/palettes`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
            respValue = await resp.json()

            if (resp.status == 200) {
                const palID = respValue.data.ID
                //console.log(palID)
            }
            resetColorsRef.current = true
            //globalContext.set(temp.current); 
            setNewThemeName("");
            setShadowOpacity(32)
            //setSelectedFont({text:fontOptions.filter(f => f.value == globalContext.get.Theme.text_font)[0], title:fontOptions.filter(f => f.value == globalContext.get.Theme.title_font)[0]})
            setShowSettings(false)
            setShowAddTheme(false)
            globalContext.set(draft=>{draft.Reloads.user=true})
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['add_theme'], textContext.value),
                ttl: 2000
            })})
        } else {
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['error_theme'], textContext.value),
                ttl: 2000
            })})
        }
    }
    const changeColor = async (e) => {

        try {
            document.getElementById(e.target.id).value = e.target.value;
            colorRef.current = e.target.value
        }
        catch {
            return
        }
    }
    const changeTheme = (e) => {
        if (isInteger(e.value)) {
            const Theme = {
                name: globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].pal_name,
                palette: [
                    globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].color_1,
                    globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].color_2,
                    globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].color_3,
                    globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].color_4,
                    globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].color_5,
                    globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].color_6,
                    globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].color_7,
                ],
                text_font: globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].Font.fon_text,
                title_font: globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].Font.fon_title,
                text_size: globalContext.get.User.Palettes.filter(pal => pal.ID == e.value)[0].Font.fon_size,
            }
            globalContext.set(draft => { draft.Theme = Theme })
        } else {
            globalContext.set(draft => { draft.Theme = defaultPalettes.filter(pal => pal.name == e.value)[0] })
        }
    }

    useEffect(() => {
        setResetColors(true)
        setSelectedFont({ text: fontOptions.filter(f => f.value == globalContext.get.Theme.text_font)[0], title: fontOptions.filter(f => f.value == globalContext.get.Theme.title_font)[0] })
    }, [resetColors])
    useEffect(() => {
        if (resetColorsRef.current) {
            setResetColors(false)
            resetColorsRef.current = false
        }
        if (globalContext.get) {
            setThemeOptions(defaultPalettes.map(palette => ({ label: palette.name, value: palette.name })).concat(globalContext.get.User.Palettes.map(pal => ({ label: pal.pal_name, value: pal.ID }))))
            setSelectedFont({ text: fontOptions.filter(f => f.value == globalContext.get.Theme.text_font)[0], title: fontOptions.filter(f => f.value == globalContext.get.Theme.title_font)[0] })
        }
    }, [globalContext.get])
    
    const resetColorsRef = useRef(false)
    const colorRef = useRef("")

    return (
        <>
            <Row className='mt-4'>
                <Form.Label>
                    <span className='d-flex'>
                        <p style={{ marginRight: 'auto' }}>{textContext.get(['sidebar', 'settings', 'theme'], ['theme_select'], textContext.value)}</p>
                        {getPermission('gro_add_theme') ? (
                            <button type='button' className='nac-button mb-2' onClick={() => setShowSave(true)}>
                                {textContext.get(['sidebar', 'settings', 'groups'], ['add'], textContext.value)}
                            </button>
                        ) : (<></>)}
                    </span>
                </Form.Label>
                <Select
                    id='select-pttp'
                    components={animatedComponents}
                    options={themeOptions}
                    value={{ label: globalContext.get.Theme.name, value: globalContext.get.Theme.name }}
                    onChange={(e) => changeTheme(e)}
                />
            </Row>

            <Modal show={showSave} onHide={() => setShowSave(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color'>{textContext.get(['sidebar', 'settings', 'save_modal'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>
                        {textContext.get(['sidebar', 'settings', 'save_modal'], ['body'], textContext.value)}
                    </p>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col className='d-flex justify-content-start'>
                            <Button variant='success' onClick={() => setShowSave(false)}>{textContext.get(['sidebar', 'settings', 'save_modal'], ['cancel'], textContext.value)}</Button>
                        </Col>
                        <Col className='d-flex justify-content-center'>
                            <Button variant='danger' onClick={() => { globalContext.set(temp.current); setShowAddTheme(true); setShowSave(false);  }} >{textContext.get(['sidebar', 'settings', 'save_modal'], ['not_save'], textContext.value)}</Button>
                        </Col>
                        <Col className='d-flex justify-content-end'>
                            <Button variant='success' onClick={() => { editUser(false); setShowAddTheme(true); setShowSave(false);  }} >{textContext.get(['sidebar', 'settings', 'save_modal'], ['save'], textContext.value)}</Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
            <Modal show={showAddTheme} onHide={() => setShowAddTheme(false)}>
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title light-color'>{textContext.get(['sidebar', 'settings', 'add_theme'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <Row className='mt-4'>
                        <InputGroup hasValidation>
                            <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'add_theme'], ['theme_name'], textContext.value)}</InputGroup.Text>
                            <FormControl
                                type='text'
                                placeholder={textContext.get(['sidebar', 'settings', 'add_theme'], ['title'], textContext.value)}
                                value={newThemeName}
                                onChange={(e) => {
                                    setNewThemeName(e.target.value);
                                    checkForm({ name: e.target.value }, editThemeCheks, setEditThemeCheks, true);
                                }}
                                onFocus={(e) => setEditThemeCheks(draft => { draft.touched.name = true })}
                                isValid={editThemeCheks.good.name}
                                isInvalid={editThemeCheks.bad.name}

                            />
                        </InputGroup>
                    </Row>
                    <hr />
                    <Row className='my-4'>
                        <Form.Label style={{ marginBottom: 0 }} ><p>{textContext.get(['sidebar', 'settings', 'add_theme'], ['text_font'], textContext.value)}</p></Form.Label>
                        <Select
                            id='select-pffp'
                            components={animatedComponents}
                            options={fontOptions}
                            value={selectedFont.text}
                            onChange={(e) => { globalContext.set(draft => { draft.Theme.text_font = e.value }); setSelectedFont({ text: e, title: selectedFont.title }) }}
                        />
                        <Form.Label style={{ marginBottom: 0, marginTop: "1rem" }}><p>{textContext.get(['sidebar', 'settings', 'add_theme'], ['title_font'], textContext.value)}</p></Form.Label>
                        <Select
                            id='select-pffdp'
                            components={animatedComponents}
                            options={fontOptions}
                            value={selectedFont.title}
                            onChange={(e) => { globalContext.set(draft => { draft.Theme.title_font = e.value }); setSelectedFont({ text: selectedFont.text, title: e }) }}
                        />
                        <Form.Label style={{ marginBottom: 0, marginTop: "1rem" }}><p>{textContext.get(['sidebar', 'settings', 'add_theme'], ['font_dimension'], textContext.value)}</p></Form.Label>
                        {/* <Form.Range
                    type='range'
                    value={parseFloat(globalContext.get.Theme.text_size) * 10}
                    min={130}
                    max={200}
                    onChange={(e) => globalContext.set(draft => { draft.Theme.text_size = parseFloat(e.target.value) / 10 })}
                //onBlur={(e) => globalContext.set(draft => { draft.Theme.palette[5] = `${draft.Theme.palette[5].slice(0, 7)}${decimalToHex(e.target.value, 2)}` })}
                /> */}
                        <span className='sidebar-font-select-container'>
                            <RiFontSize className={`sidebar-font-select-item ${globalContext.get && globalContext.get.Theme.text_size == 12 && 'sidebar-font-select-item-active'}`} size={'24pt'}
                                onClick={(e) => globalContext.set(draft => { draft.Theme.text_size = 12 })}
                            />
                            <RiFontSize className={`sidebar-font-select-item ${globalContext.get && globalContext.get.Theme.text_size == 14 && 'sidebar-font-select-item-active'}`} size={'28pt'}
                                onClick={(e) => globalContext.set(draft => { draft.Theme.text_size = 14 })}
                            />
                            <RiFontSize className={`sidebar-font-select-item ${globalContext.get && globalContext.get.Theme.text_size == 16 && 'sidebar-font-select-item-active'}`} size={'32pt'}
                                onClick={(e) => globalContext.set(draft => { draft.Theme.text_size = 16 })}
                            />
                        </span>
                    </Row>
                    <hr />
                    <Row className='mt-4'>
                        <p>{textContext.get(['sidebar', 'settings', 'add_theme'], ['sub_title1'], textContext.value)}</p>
                        {resetColors && (
                            <>
                                <InputGroup className='mt-2'>
                                    <InputGroup.Text style={{ minWidth: "6vw" }} >{textContext.get(['sidebar', 'settings', 'add_theme'], ['color1'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='color'
                                        id='colorPicker0'
                                        defaultValue={globalContext.get.Theme.palette[0]}
                                        onChange={(e) => changeColor(e)}
                                        onBlur={(e) => { globalContext.set(draft => { draft.Theme.palette[0] = colorRef.current }); }}
                                    />
                                </InputGroup>
                                <InputGroup className='mt-2'>
                                    <InputGroup.Text style={{ minWidth: "6vw" }}>{textContext.get(['sidebar', 'settings', 'add_theme'], ['color2'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='color'
                                        id='colorPicker1'
                                        defaultValue={globalContext.get.Theme.palette[1]}
                                        onChange={(e) => changeColor(e)}
                                        onBlur={(e) => { globalContext.set(draft => { draft.Theme.palette[1] = colorRef.current }); }}
                                    />
                                </InputGroup>
                                <InputGroup className='mt-2'>
                                    <InputGroup.Text style={{ minWidth: "6vw" }}>{textContext.get(['sidebar', 'settings', 'add_theme'], ['color3'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='color'
                                        id='colorPicker2'
                                        defaultValue={globalContext.get.Theme.palette[2]}
                                        onChange={(e) => changeColor(e)}
                                        onBlur={(e) => { globalContext.set(draft => { draft.Theme.palette[2] = colorRef.current }); }}
                                    />
                                </InputGroup>
                                <InputGroup className='mt-2'>
                                    <InputGroup.Text style={{ minWidth: "6vw" }}>{textContext.get(['sidebar', 'settings', 'add_theme'], ['color4'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='color'
                                        id='colorPicker3'
                                        defaultValue={globalContext.get.Theme.palette[3]}
                                        onChange={(e) => changeColor(e)}
                                        onBlur={(e) => { globalContext.set(draft => { draft.Theme.palette[3] = colorRef.current }); }}
                                    />
                                </InputGroup>
                                <InputGroup className='mt-2'>
                                    <InputGroup.Text style={{ minWidth: "6vw" }}>{textContext.get(['sidebar', 'settings', 'add_theme'], ['color5'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='color'
                                        id='colorPicker4'
                                        defaultValue={globalContext.get.Theme.palette[4]}
                                        onChange={(e) => changeColor(e)}
                                        onBlur={(e) => { globalContext.set(draft => { draft.Theme.palette[4] = colorRef.current }); }}
                                    />
                                </InputGroup>
                                <InputGroup className='mt-2'>
                                    <InputGroup.Text style={{ minWidth: "6vw" }}>{textContext.get(['sidebar', 'settings', 'add_theme'], ['color6'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='color'
                                        id='colorPicker6'
                                        defaultValue={globalContext.get.Theme.palette[6]}
                                        onChange={(e) => changeColor(e)}
                                        onBlur={(e) => { globalContext.set(draft => { draft.Theme.palette[6] = colorRef.current }); }}
                                    />
                                </InputGroup>
                                <InputGroup className='mt-2'>
                                    <InputGroup.Text >{textContext.get(['sidebar', 'settings', 'add_theme'], ['shadows'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='color'
                                        id='colorPicker5'
                                        defaultValue={globalContext.get.Theme.palette[5]}
                                        onChange={(e) => changeColor(e)}
                                        onBlur={(e) => { globalContext.set(draft => { draft.Theme.palette[5] = `${colorRef.current}${decimalToHex(shadowOpacity, 2)}` }); }}
                                    />
                                    <InputGroup.Text >{textContext.get(['sidebar', 'settings', 'add_theme'], ['shadow_opacity'], textContext.value)}</InputGroup.Text>
                                    <FormControl
                                        type='range'
                                        value={shadowOpacity}
                                        min={0}
                                        max={100}
                                        onChange={(e) => setShadowOpacity(e.target.value)}
                                        onBlur={(e) => globalContext.set(draft => { draft.Theme.palette[5] = `${draft.Theme.palette[5].slice(0, 7)}${decimalToHex(e.target.value, 2)}` })}
                                    />
                                </InputGroup>
                            </>
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col xs={9} >
                        </Col>
                        <Col xs={2} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button' onClick={() => { resetColorsRef.current = true; globalContext.set(temp.current); setNewThemeName(""); setShadowOpacity(32); }}>
                                <RiEraserLine size={`24pt`} />
                            </button>
                        </Col>
                        <Col xs={1} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button' onClick={() => addTheme()}>
                                <RiMenuAddLine size={`24pt`} />
                            </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default ThemeSettings